import {genAIVendorUiName} from './aiImages.consts';
import {
  GenAiService,
  ImageAnalysisResponse,
  RemoteGenAiService,
  RemoteImageAnalysisResponse,
  VendorService,
} from './aiImages.types';

function addBase64Prefix(image: string): string {
  return `data:image/png;base64,${image}`;
}

function toClientGenAiService({action, services}: RemoteGenAiService): GenAiService {
  return {
    action: action,
    services: services.map(({vendorService, description, vendor, serviceUiName}) => ({
      label: `${genAIVendorUiName[vendor]}${serviceUiName ? ` - ${serviceUiName}` : ''}`,
      value: vendorService,
      description: description,
    })),
    vendorServices: services.map(({vendorService, vendor, serviceUiName, description}): VendorService => ({
      vendorService,
      vendor,
      serviceUiName,
      description,
    })),
  };
}

function toRemoteMaskImage(canvas: HTMLCanvasElement) {
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;

  const tempCtx = tempCanvas.getContext('2d');

  if (!tempCtx) {
    throw new Error('Failed to get 2d context from canvas');
  }

  tempCtx.drawImage(canvas, 0, 0);

  const imgData = tempCtx.getImageData(0, 0, tempCanvas.width, tempCanvas.height);
  const data = imgData.data;

  for (let i = 0; i < data.length; i += 4) {
    const alpha = data[i + 3];

    if (alpha > 0) {
      // Any non-transparent pixel becomes fully opaque white
      data[i] = 255;
      data[i + 1] = 255;
      data[i + 2] = 255;
      data[i + 3] = 255;
    } else {
      // Transparent pixels stay transparent
      data[i] = 0;
      data[i + 1] = 0;
      data[i + 2] = 0;
      data[i + 3] = 0;
    }
  }

  tempCtx.putImageData(imgData, 0, 0);

  return tempCanvas;
}

// Since ImageAnalysisResponse is now a type alias for RemoteImageAnalysisResponse,
// this function is just a pass-through but keeps the API consistent
function toClientImageAnalysis(response: RemoteImageAnalysisResponse): ImageAnalysisResponse {
  return response;
}

export {
  addBase64Prefix,
  toClientGenAiService,
  toClientImageAnalysis,
  toRemoteMaskImage,
};
